module.exports = __webpack_public_path__ + "static/img/m_ol5.f5cd87b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/m_ol5.jpg
// module id = vCL+
// module chunks = 0